export function buildRegistryContext(name: string) {
  return { name };
}
